export const quantumPageIT = {
  "seo": {
    "title": "LLM Sovrani & IA Quantistica | pAIoneer Labs GmbH",
    "description": "Il nostro obiettivo dalla Germania: sotto Veridion («l'IA sviluppa ulteriormente l'IA»), sviluppare modelli linguistici compatti e Quantum Transformer che competeranno con i grandi modelli USA e cinesi."
  },
  "hero": {
    "kicker": "Made in Germany · L'IA sviluppa l'IA",
    "title": "LLM Sovrani & IA Quantistica",
    "claim": "Il nostro obiettivo dalla Germania: sviluppare modelli linguistici e Quantum Transformer proprietari che in futuro competeranno con i grandi modelli di Stati Uniti e Cina.",
    "subtitle": "In progetti aziendali reali, gli approcci europei finora disponibili — i modelli tedeschi di Aleph Alpha (come Kolibri), i modelli francesi intorno a Mistral, EuroLLM e in particolare il modello svizzero Apertus — sono stati valutati su problemi pratici d'impresa. Nessuno soddisfa i requisiti aziendali. Per questo la nostra IA sotto [Veridion](veridion) («l'IA sviluppa ulteriormente l'IA») compie il passo successivo: studia e progetta il percorso verso modelli linguistici compatti Made in Germany che saranno nettamente superiori ai modelli francesi, portando avanti come secondo pilastro i propri Quantum Transformer.",
    "cta": "Fissa un colloquio"
  },
  "pillars": {
    "title": "Su cosa lavora la nostra IA",
    "subtitle": "Due ambiti di ricerca in cui i nostri collaboratori digitali progettano nuove architetture, le verificano nel simulatore e le costruiscono passo dopo passo.",
    "items": [
      {
        "title": "Cosa deve garantire un modello nel lavoro quotidiano",
        "description": "Nell'impiego reale contano il ragionamento logico multi-step, l'uso affidabile degli strumenti su lunghe catene operative, lo sviluppo software pulito e processi d'ufficio privi di errori. Su questo misuriamo ogni architettura fin dall'inizio."
      },
      {
        "title": "Modelli compatti per la propria infrastruttura",
        "description": "Invece di data center sempre più grandi, il nostro obiettivo sarà concentrare un'elevata profondità di ragionamento in un modello compatto che le aziende potranno eseguire localmente sul proprio hardware."
      },
      {
        "title": "Quantum Transformer & IA Quantistica",
        "description": "Nel secondo ambito studiamo come unire architetture transformer, circuiti quantistici parametrizzati e reti tensoriali per aprire nuove classi di modelli oltre le reti classiche."
      },
      {
        "title": "Quantum IDE propria & processori quantistici reali",
        "description": "Nella nostra Quantum IDE sviluppata internamente, i collaboratori IA progettano, simulano e testano nuovi circuiti quantistici rispetto a baseline classiche prima dell'esecuzione su vero hardware quantistico."
      }
    ]
  },
  "gate": {
    "title": "Dallo stato dell'arte al progetto esecutivo",
    "subtitle": "Ogni passo di sviluppo poggia su letteratura verificata, memoria aziendale e confronti misurabili.",
    "stages": [
      {
        "step": "Fase 01",
        "title": "Analisi della letteratura & memoria aziendale",
        "description": "I nostri collaboratori IA analizzano costantemente i più recenti lavori scientifici sulle architetture linguistiche e quantistiche, registrando tutti i risultati verificati nel grafo di conoscenza aziendale."
      },
      {
        "step": "Fase 02",
        "title": "Piano di addestramento & simulazione circuitale",
        "description": "Insieme allo Sviluppo Prodotto nasce così la roadmap dettagliata per il nostro futuro modello linguistico, mentre in parallelo vengono sperimentati nuovi circuiti nella Quantum IDE."
      },
      {
        "step": "Fase 03",
        "title": "Verifica scientifica nel processo IDD",
        "description": "Fisici e ricercatori IA esaminano ogni ipotesi, misura e progetto tramite [Intent-Driven Development](idd) (IDD) come human-in-the-loop e approvano il passo successivo."
      }
    ]
  },
  "stack": {
    "title": "Uomo e IA in un'unica unità di ricerca",
    "subtitle": "Ricerca, sviluppo prodotto e supervisione scientifica si integrano in cicli fissi.",
    "items": [
      {
        "title": "Ricercatori digitali sempre attivi",
        "description": "Collaboratori IA specializzati svolgono ricerca bibliografica, derivazioni matematiche, progettazione di circuiti e valutazioni ventiquattr'ore su ventiquattro."
      },
      {
        "title": "Fisici in Human-in-the-Loop",
        "description": "Gli scienziati umani definiscono la direzione di ricerca, mettono alla prova le ipotesi e decidono su approvazioni, esecuzioni hardware e pubblicazioni."
      },
      {
        "title": "Integrazione con lo Sviluppo Prodotto",
        "description": "In stretto raccordo con il nostro team di prodotto, i risultati di ricerca validati confluiscono direttamente nei nostri strumenti e nelle future soluzioni aziendali."
      },
      {
        "title": "Tracciabile fino alla fonte",
        "description": "Ogni decisione architetturale, variante scartata e risultato di misura resta documentato in modo permanente e verificabile in qualsiasi momento."
      }
    ]
  },
  "cta": {
    "title": "Confronto sulla ricerca",
    "subtitle": "Desideri confrontarti sulla nostra ricerca sui modelli linguistici sovrani e sui Quantum Transformer? Scrivici.",
    "button": "Scrivi un messaggio"
  }
};
